//libs
import React from 'react';

//styles
import { ExpiryContainer, CountdownTimer, CountdownTimerOver } from './styles';

//constants
import { COUPON_EXPIRY } from './constants';

//defs
interface CouponExpiryProps {
  expiryDate: number;
  isApplied?: boolean;
  isOffer?: boolean;
  className?: string;
  setIsExpired?: (hasExpired: boolean) => void;
  timerOver?: boolean;
}

const { COUPON_EXPIRY_TEXT, OFFER_EXPIRY_TEXT, APPLIED_OFFER_EXPIRING, EXPIRED_TIMER_TEXT } =
  COUPON_EXPIRY;

const CouponsExpiry = ({
  expiryDate,
  isApplied = false,
  isOffer = false,
  className = '',
  setIsExpired,
  timerOver = false,
}: CouponExpiryProps) => {
  return (
    <ExpiryContainer
      isOffer={isOffer}
      className={className + ' coupon-expiry'}
      data-test="coupon-expiry"
    >
      {isOffer ? (isApplied ? APPLIED_OFFER_EXPIRING : OFFER_EXPIRY_TEXT) : COUPON_EXPIRY_TEXT}{' '}
      {timerOver ? (
        <CountdownTimerOver className="coupon-timer">{EXPIRED_TIMER_TEXT}</CountdownTimerOver>
      ) : (
        <CountdownTimer
          countDownTime={expiryDate}
          className="coupon-timer"
          setIsExpired={setIsExpired}
        />
      )}
    </ExpiryContainer>
  );
};

export default CouponsExpiry;
